import {
    DIC
} from '@/const/dic'
// import {
//     validateChinese
// } from '@/util/validate'
// import {
//     formatterTime
// } from '@/util/util'
import {
    baseUrl
} from '@/config/env';


export const engineerLeaderOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    columnBtn: false,
    //viewBtn: true,
    menuWidth: '200',
    labelWidth: '150',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [
        {
            label: "用户类型",
            prop: "clientType",
            type: 'input',
            dicData:DIC.CLIENT_TYPE,
            addVisdiplay: false,
            editVisdiplay: false
        }, 
        {
            label: "姓名",
            prop: "username",
            type: 'input',
            search:true,
            addVisdiplay: false,
            editVisdiplay: false
        }, 
        {
            label: "手机号",
            prop: "mobile",
            type: 'input',
            search:true,
            addVisdiplay: false,
            editVisdiplay: false
        }, 
        {
            label: "工程师",
            prop: "name",
            type: 'select',
            formsolt:true,
            hide:true,
        },
        {
            label: "绑定时间",
            prop: "createTime",
            type: "datetime",
            // sortable: true,
            valueFormat: "timestamp",
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "更新人",
            prop: "createBy",
            type: "input",
            hide:true,
            addVisdiplay: false,
            editVisdiplay: false,
            width: "110"
        },
    ]
};